const CSRF_SYNC_TIMEOUT_MS = 10000;
const CSRF_SYNC_BURST_ATTEMPTS = 2;

export const applyCsrfToken = (token) => {
    if (!token) {
        return '';
    }

    let meta = document.head.querySelector('meta[name="csrf-token"]');

    if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'csrf-token';
        meta.id = 'csrf-token';
        document.head.appendChild(meta);
    }

    meta.setAttribute('content', token);

    document.querySelectorAll('input[name="_token"]').forEach((input) => {
        input.value = token;
    });

    window.livewireScriptConfig = window.livewireScriptConfig || {};
    window.livewireScriptConfig.csrf = token;

    return token;
};

export const readCsrfTokenFromDom = () => {
    const meta = document.querySelector('meta[name="csrf-token"]');
    const metaToken = meta?.getAttribute('content') || '';

    if (metaToken) {
        return metaToken;
    }

    return document.querySelector('input[name="_token"]')?.value || '';
};

const requestCsrfToken = async () => {
    let lastError = null;

    for (let attempt = 1; attempt <= CSRF_SYNC_BURST_ATTEMPTS; attempt += 1) {
        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), CSRF_SYNC_TIMEOUT_MS);

        try {
            const response = await fetch('/csrf', {
                credentials: 'same-origin',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                signal: controller.signal,
            });

            if (!response.ok) {
                throw new Error(`CSRF token request failed with status ${response.status}`);
            }

            const data = await response.json();
            const token = applyCsrfToken(data?.token || '');

            if (token) {
                return { token, error: null };
            }

            throw new Error('CSRF token response did not contain a token');
        } catch (error) {
            lastError = error?.name === 'AbortError'
                ? new Error(`CSRF token request timed out after ${CSRF_SYNC_TIMEOUT_MS} ms`)
                : error;
        } finally {
            window.clearTimeout(timeoutId);
        }
    }

    return { token: '', error: lastError };
};

export const ensureCsrfTokenResult = async () => {
    if (!window.__vsebankiCsrfTokenPromise) {
        window.__vsebankiCsrfTokenPromise = requestCsrfToken();
    }

    const result = await window.__vsebankiCsrfTokenPromise;

    if (!result.token) {
        window.__vsebankiCsrfTokenPromise = null;
    }

    return result;
};

export const ensureCsrfToken = async () => (await ensureCsrfTokenResult()).token;

export const resetCsrfToken = () => {
    window.__vsebankiCsrfTokenPromise = null;
};

if (typeof window !== 'undefined') {
    window.__vsebankiApplyCsrfToken = window.__vsebankiApplyCsrfToken || applyCsrfToken;
    window.__vsebankiEnsureCsrfToken = window.__vsebankiEnsureCsrfToken || ensureCsrfToken;
};
